import sessionApi from "../../api/session";
import * as mutationTypes from "../mutation-types";
// Issue 2188: router は packs/application.js からも静的インポートされており、
// 常にエントリーチャンクに含まれる。そのため本ファイルで動的インポートしても
// チャンク分離の効果はなく、Rollup の静的/動的インポート混在警告の原因になっていた。
// 効果のない動的インポートをやめ、静的インポートに統一する。
import router from "../../routes/index";

const state = {
  currentDoctor: null,
  loggedIn: false,
  emailLoginEnabled: false
};

const getters = {
  loggedIn: state => state.loggedIn,
  loginAction: state => state.loginAction,
  currentDoctor: state => state.currentDoctor,
  capabilities: state => {
    const doctor = state.currentDoctor;
    if (!doctor) return [];

    return Array.isArray(doctor.capabilities) ? doctor.capabilities : [];
  },
  hasAllCapabilities: (state, getters) => (required = []) => {
    if (!required || required.length === 0) return true;

    const capabilities = getters.capabilities || [];
    return required.every(capability => capabilities.includes(capability));
  },
  doctorName: state => state.currentDoctor?.name || "",
  doctorProfileUrl: state => {
    const doctor = state.currentDoctor;
    if (!doctor?.obstetricsHost || !doctor?.id) return "";
    return `${doctor.obstetricsHost}/doctors/${doctor.id}`;
  },
  emailLoginEnabled: state => state.emailLoginEnabled
};


const actions = {
  login({ commit, dispatch }, params) {
    return new Promise((resolve) => {
      sessionApi.login((result) => {
        const { loggedIn, error } = result;
        let loginAction = true;
        commit(mutationTypes.ASSIGN_LOGGED_IN, { loggedIn });
        if( loggedIn == true ){
          dispatch("fetchCurrentDoctor").then(()=> {
            if(params.redirectPath){
              router.push(params.redirectPath);
            } else {
              // 権限によりログイン先が変わる
              router.push(state.currentDoctor.homeUrl);
            }
          });
        }
        resolve({ loggedIn, error });
      }, params);
    });
  },

  logout({ commit }) {
    return new Promise((resolve) => {
      sessionApi.logout(loggedIn => {
        commit(mutationTypes.ASSIGN_LOGGED_IN, { loggedIn });
        let currentDoctor = null;
        commit(mutationTypes.ASSIGN_CURRENT_DOCTOR, { currentDoctor });
        router.push("/login").catch(() => {}).finally(() => resolve());
      });
    });
  },

  checkLoggedIn({ commit, dispatch }) {
    return new Promise((resolve) => {
      sessionApi.checkLoggedIn(loggedIn => {
        commit(mutationTypes.ASSIGN_LOGGED_IN, { loggedIn });
        if(loggedIn){
          dispatch("fetchCurrentDoctor");
        }
        resolve();
      });
    });
  },

  fetchCurrentDoctor({ commit }) {
    return new Promise((resolve) => {
      sessionApi.fetchCurrentDoctor(currentDoctor => {
        commit(mutationTypes.ASSIGN_CURRENT_DOCTOR, { currentDoctor });
        if (currentDoctor.id > 0) {
          let loggedIn = true;
          commit(mutationTypes.ASSIGN_LOGGED_IN, { loggedIn });
        }
        resolve();
      });
    });
  },

  fetchAuthSetting({ commit }) {
    return new Promise((resolve) => {
      sessionApi.fetchAuthSetting(setting => {
        let emailLoginEnabled = setting.email_login_enabled;
        commit(mutationTypes.EMAIL_LOGIN_ENABLED, { emailLoginEnabled });
        resolve();
      });
    });
  },
};


const mutations = {
  [mutationTypes.ASSIGN_LOGIN_ACTION](state, { loginAction }) {
    state.loginAction = loginAction;
  },

  [mutationTypes.ASSIGN_LOGGED_IN](state, { loggedIn }) {
    state.loggedIn = loggedIn;
  },

  [mutationTypes.ASSIGN_CURRENT_DOCTOR](state, { currentDoctor }) {
    state.currentDoctor = currentDoctor;
  },

  [mutationTypes.EMAIL_LOGIN_ENABLED](state, { emailLoginEnabled }) {
    state.emailLoginEnabled = emailLoginEnabled;
  }
};


export default {
  state,
  getters,
  actions,
  mutations
};
